<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
 <g>
  <rect stroke="#a6ce39" rx="5" id="svg_1" height="18" width="18" y="3" x="3" fill="#a6ce39"/>
  <text font-style="normal" font-weight="normal" xml:space="preserve" text-anchor="start" font-family="'Poppins SemiBold'" font-size="12" stroke-width="0" id="svg_2" y="16.68255" x="7.87037" stroke="#ffffff" fill="#ffffff">V</text>
 </g>
</svg>